<template>
<div>
    <ob-modal2 :show.sync="show" width="900px" :backdrop="false">
        <template slot="modal-title">
            <div class="modal-head">
                <h4 class="modal-title">
                   Upload Physical Signed I-983
                </h4>
            </div>
        </template>
        <template slot="modal-body">
         <template>
             <div class="row rowgap">
                  <div class="col-md-12">
                    <div class="form-group">
                        <label style="font-size: 14px">Please upload the physically signed copy of Form I-983</label>
                    </div>
                  </div>
             </div>
             <label> Select form I-983 status</label>
             <div class="row rowgap">
                <div class="col-md-4">
                    <div class="form-group">
                       <div class="radio-inline">
                           <ob-radio :disabled="IsPrimaryExist" name="I983Type"  val="Primary" v-model="I983Type">Primary I-983</ob-radio>
                      </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <div class="radio-inline">
                           <ob-radio name="I983Type" val="MaterialChange" v-model="I983Type">Material Change</ob-radio>
                       </div>
                    </div>
                </div>
                <div class="col-md-4 ">
                    <div class="form-group">
                       <div class="radio-inline">
                           <ob-radio name="I983Type" val="Evaluation" v-model="I983Type">Student Evaluation</ob-radio>
                      </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="I983Type == 'MaterialChange' && $parent.IsFinalEvaluationDone">
                <div class="col-md-12">
                    <p class="rcss-text-warning"><i class="fa fa-warning"></i> Final evaluation is completed for this student. If you have to do material change it has to be prior to the final evaluation.</p>
                </div>
            </div>
             <div class="row rowgap">
                <div class="col-md-4">
                    <div class="form-group">
                         <label>Completed/Signed Date</label><span class="validation-star">*</span>
                         <ob-date-time-picker id="signedDate" :inputvalue="SignedDate" placeholder="select date" :options="options1" @updated="(v) => this.SignedDate = v"  v-model.trim="SignedDate"  :class="{ 'ob-vuelidate_input-error': $v.SignedDate.$error }" @input="$v.SignedDate.$touch()"></ob-date-time-picker>
                         <span class="ob-vuelidate_error-msg" v-if="$v.SignedDate.$dirty && !$v.SignedDate.required">Enter Signed Date</span>
                    </div>
                </div>
             </div>
             <template v-if="I983Type == 'MaterialChange'">
             <!-- MaterialChange -->
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <p class="title-content">Material Change Information</p>
                    </div>
                </div>
            </div>
            <div class="row rowgap">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Select Material Change</label>
                             <ob-select2 :options="materialChangeOptions" placeholder="select material change" :multiple="true" v-model="MaterialChange" :change="onMaterialChange" ></ob-select2>

                        </div>
                    </div>
            </div>

             <template v-if="showSpecifyReason">
                <div class="row rowgap">
                    <div class="col-md-12">
                    <div class="form-group">
                        <label>Specify reason for others</label><span class="validation-star">*</span>
                        <ob-textarea :maxLength="150" v-model.trim="SpecifyReason" placeholder="Enter Specify Reason" :class="{ 'ob-vuelidate_input-error': $v.SpecifyReason.$error }"></ob-textarea>
                        <span class="ob-vuelidate_error-msg" v-if="$v.SpecifyReason.$dirty && !$v.SpecifyReason.requiredIf">Enter Specify Reason</span>
                    </div>
                    </div>
                </div>
            </template>

             </template>
             <template v-if="I983Type == 'Evaluation'">
             <!-- Evaluation -->
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <p class="title-content">Student Evaluation Information</p>
                    </div>
                </div>


            </div>
            <div class="row rowgap">
                    <div class="col-md-4">
                        <div class="form-group">
                             <label>Range of Evaluation Date(From)</label>
                            <ob-date-time-picker  ref="rangeDateFrom" id="rangeDateFrom" placeholder="select date"  :inputvalue="StudentDetails.RangeOfEvaluationDateFrom" :options="options2" @updated="(v) => this.StudentDetails.RangeOfEvaluationDateFrom = v" :dpchange="onRangeFromDateChange" ></ob-date-time-picker>

                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                             <label>Range of Evaluation Date(To)</label>
                          <ob-date-time-picker  ref="rangeDateTo" id="rangeDateTo" placeholder="select date"  :inputvalue="StudentDetails.RangeOfEvaluationDateTo"  :options="options2" @updated="(v) => this.StudentDetails.RangeOfEvaluationDateTo = v"  ></ob-date-time-picker>
                        </div>
                    </div>
                 </div>
                     <div class="row rowgap" style="padding-left:15px">
            <div class="checkbox-inline" style="padding: 0; margin-right: 5px;"><ob-checkbox :disabled="disableFinalEvaluationCheckbox" v-model="StudentDetails.IsFinalEvalution">This is the Final Evaluation</ob-checkbox></div><i style="vertical-align: middle;" class="fa fa-info-circle" v-if="IsFinalEvaluationDone" v-tooltip="'Final Evaluation is already done. Please update the current final evaluation to enable this checkbox.'"></i>
            </div>

            </template>
            <!-- upload -->
             <div class="row" style="padding:15px 0px;">
                              <div class="col-md-12 padding-15">
                                   <label v-if="I983Type == 'Evaluation'">Upload Signed copy of Student evaluation</label>
                                   <label v-else-if="I983Type == 'MaterialChange'">Upload Signed copy of Material change</label>
                                   <label v-else-if="I983Type == 'Primary'"> Upload Signed Form I-983</label>

                                    <transition name="slide-fade">
                                        <div v-if="show">
                                            <ob-upload-new ref="child1" :end-point="EndPoint" :type="2"
                                                        :IsFileExists="docUrl | I9URL2FileName" :validation="documantValidation" :isUploading.sync="isUploading"
                                                        @remove-file="removeDocUrl"
                                                        @file-complete="uploadComplete">
                                                <template slot="file-text">
                                                    <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop   OR   Choose  The File
                                                </template>

                                            </ob-upload-new>
                                            <span class="ob-vuelidate_error-msg" style="padding-left: 5px"
                                                v-if="isErrorMessageDisabled && $refs.child1.Errors.length==0" >{{errorMessageFrmResponse}} </span>
                                        </div>
                                    </transition>
                              </div>
             </div>

            </template>
        </template>

        <template slot="modal-footer" class="modal-footer">
             <ob-button type="secondary" @click="show = false">Cancel</ob-button>
             <ob-button type="primary" :disabled="isUploading" @click="onUpload">Upload</ob-button>
        </template>
    </ob-modal2>
    </div>


</template>
<script>
import c from 'Vue/Core/constants.js'
import { required, minLength, maxLength, requiredIf, email, alpha, minValue ,maxValue } from 'vuelidate/lib/validators'
    import { req, withParams } from 'vuelidate/lib/validators/common'
      const DecimalNumber = withParams({ type: 'DecimalNumber' }, value => {
        return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
    })
     const alphawithspace = (value) => {
     var alsp = /^[a-zA-Z\s]*$/i
     return alsp.test(value)
   }
    const letterCount = withParams({ type: 'letterCount' }, value => {
        if (value !=null && value.length <= 150) {
            var strArr = value.split(" ");
            let error = true;
            strArr.forEach(function (word) {
                if (word.length > 100) {
                    error = false
                    return;
                }
            });
            return !req(value) || error
        }
        else {
            return true
        }

    })

    export default {
        props: ["openModal","previousData"],
        data(){
            return {
               IsInitiateOnlySectionType:true,
               SpecifyReason:'',
               showSpecifyReason: false,
               disableFinalEvaluationCheckbox: false,
               SignedDate:'',
               errorMessageFrmResponse:'',
               isErrorMessageDisabled: false,
                mouseOver:'',
               I983Type:'Primary',
               show: '',
               StudentDetails:
               {
                    Name:'',
                    EmailAddress:'',
                    DSOName:'',
                    DSOAddress:'',
                    DSOMail:'',
                    DSOPhone:'',
                    StudentSEVISIdNo:'',
                    STEMOPTRequestedPeriodFrom:'',
                    STEMOPTRequestedPeriodTo:'',
                    RangeOfEvaluationDateFrom:'',
                    RangeOfEvaluationDateTo:'',
                    IsFinalEvalution:'',
               },
               EmployerDetails:
               {
                    Name:'',
                    OPTHoursPerWeek:'',
                    Salary:'',
                    SalaryType:'',
                    EmploymentStartDate:'',
               },
               options1: {
                    maxDate: moment().add(0, 'days'),
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                    widgetPositioning: {
                        horizontal: "auto",
                        vertical: "bottom"
                    },
                },
                options2: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY'
                },
                 options3: {
                    format: 'MM/DD/YYYY',
                    ignoreReadonly: true,
                    widgetPositioning: {
                        horizontal: "auto",
                        vertical: "bottom"
                    }
                },
                options4: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY'
                },
                salaryOption:{
                    data: [
                    {
                        "id":"Hourly",
                        "text":"Hourly"
                    },
                    {
                        "id":"Weekly",
                        "text":"Weekly"
                    },
                    {
                        "id":"BiWeekly",
                        "text":"Bi-Weekly"
                    },
                    {
                        "id":"Monthly",
                        "text":"Monthly"
                    },
                    {
                        "id":"SemiMonthly",
                        "text":"Semi-Monthly"
                    },
                    {
                        "id":"Yearly",
                        "text":"Yearly"
                    },
                    ],
                    placeholder: "Select Salary Frequency"
                },
                MaterialChange:'',
                materialChangeOptions:{
                    data: [
                        {
                            id: "ChangeOfEmployerIdentificationNumber",
                            text: 'Change of the employer’s Employer Identification Number (i.e., the company’s Federal Tax ID number)'
                        },
                        {
                            id: "ReductionInStudentCompensation",
                            text: 'Reduction in student compensation that is not tied to a reduction in hours worked'
                        },
                        {
                            id: "DecreaseInHoursPerweek",
                            text: 'Significant decrease in hours per week that a student engages in a STEM training opportunity'
                        },
                        {
                            id: "ChangesCommitmentsOrObjectives",
                            text: 'Changes to the employer’s commitments or student’s learning objectives as documented on the Form I-983'
                        },
                        { id: "PeriodicEvaluationFromTheUniversity", text: 'Periodic evaluation from  the University' },
                        {
                        id:"ChangeInEmployerSite",
                        text:"Change in employer site"
                        },
                        { id: "Others" , text: 'Others'}
                    ],
                   placeholder: {
                    id: '-1',
                    text: 'Please select'
                }
                },
                 //upload doc
                 docUrl:'',
                 EndPoint: `${c.APIBASEURL}/File/FileUpload`,
                 isUploading: false,
                 documantValidation: {
                        Rules: {
                            Type: ["pdf", "zip", "doc", "docx", "png", "gif", "jpg", "jpeg"],
                            Size: 110000000, // In Bytes
                            multiplefiles: false
                        },
                        Messages: {
                            Type: "Please upload valid file formats",
                            Size: `Please upload a file which is less than 100MB`,
                        }
                   },
            }
        },
        watch: {
            I983Type(val)
            {
              this.I983TypeChange(val);
            },
            openModal(val) {
                this.show = val;

            },
            show(val) {
                this.$emit('update:openModal', val)
            },
        },
        computed: {
            onMaterialChange()
            {
                this.showSpecifyReason = false
                if(this.MaterialChange)
                {
                   for (var i = 0; i < this.MaterialChange.length; i++) {
                        if(this.MaterialChange[i] == 'Others'){
                            this.showSpecifyReason = true
                        }
                    }
                }
            },
            IsPrimaryExist()
            {
                var list = this.$parent.clonedList;
                if (list != null && list.filter(e => e.Type === 'Primary').length > 0) {

                    this.I983Type='MaterialChange'
                    return true
                }
                else return false
            },
            EmployeeId() {
                return this.$parent.$parent.EmployeeId;
            },
            StudentName() {
                return this.$parent.$parent.StudentName;
            },
            ConsultantId(){
                return this.$route.params.id
            },
            ConsultantDetails(){
               return this.$parent.$parent.consultantDetails;
            },
            EmploymentStartDate()
            {
              return this.$parent.$parent.EmploymentStartDate
            },
            IsFinalEvaluationDone() {
                return this.$parent.$parent.IsFinalEvaluationDone;
            }
        },
        created()
        {
           this.show = this.openModal
           this.copyFromStore()
        },
         validations(){
                    return{
                                "SignedDate":{
                                    required
                                },

                                // "StudentDetails":
                                // {
                                //     Name:
                                //     {
                                //         required,
                                //         maxLength: maxLength(150),
                                //         letterCount
                                //     },
                                //     EmailAddress:
                                //     {
                                //             required,
                                //             email
                                //     },
                                //     DSOMail:{
                                //         email
                                //     },
                                //     DSOPhone:{
                                //         maxLength: maxLength(20),
                                //         minLength: minLength(10)
                                //     },
                                // },
                                // "EmployerDetails":
                                // {

                                //     Name:
                                //     {
                                //         required,
                                //         maxLength: maxLength(150),
                                //         letterCount
                                //     },
                                //     OPTHoursPerWeek:{
                                //         minValue: minValue(20),
                                //         maxValue: maxValue(40)
                                //     },
                                //     Salary:{
                                //         minValue: minValue(1)
                                //     },
                                // },
                                 SpecifyReason:{
                                      requiredIf: requiredIf(()=>{
                                        if (this.MaterialChange.indexOf("Others") > -1){
                                                return true
                                            }
                                            else{
                                                return false
                                            }
                                        })
                                    }

                    }
         },
        methods:{
        I983TypeChange(type)
        {
            // Reset Validations
            this.$v.SpecifyReason.$reset();

            this.MaterialChange = "",
            this.SpecifyReason = "",
            this.StudentDetails.RangeOfEvaluationDateFrom = "",
            this.StudentDetails.RangeOfEvaluationDateTo = "",
            this.StudentDetails.IsFinalEvalution = false;
            this.IsInitiateOnlySectionType = false;

        },
        copyFromStore() {
                if(this.previousData != null && this.previousData != '' && this.show)
                {
                    this.StudentDetails.Name = this.previousData.Employee.Name;
                    this.StudentDetails.EmailAddress = this.previousData.Employee.Email;
                    this.StudentDetails.DSOName = this.previousData.Employee.DSO;
                    this.StudentDetails.DSOMail = this.previousData.Employee.DSOMail;
                    this.StudentDetails.DSOPhone = this.previousData.Employee.DSOPhone;
                    this.StudentDetails.DSOAddress = this.previousData.Employee.DSOAddress;
                    this.StudentDetails.StudentSEVISIdNo = this.previousData.Employee.SEVISID;
                    this.StudentDetails.STEMOPTRequestedPeriodFrom = this.previousData.Employee.RequestedFrom;
                    this.StudentDetails.STEMOPTRequestedPeriodTo = this.previousData.Employee.RequestedTo;

                    this.EmployerDetails.Name = this.previousData.Employer.Name;
                    this.EmployerDetails.OPTHoursPerWeek = this.previousData.Employer.OPTHours;
                    this.EmployerDetails.Salary = this.previousData.Employer.Salary;
                    this.EmployerDetails.SalaryType = this.previousData.Employer.SalaryFrequency;
                    this.EmployerDetails.EmploymentStartDate = this.previousData.Employer.EmploymentStartDate;
                }
                else if(this.ConsultantDetails != null && this.ConsultantDetails != '' && this.show)
                {
                    this.getCurrentOrganizationDetails();
                    this.StudentDetails.Name =  this.ConsultantDetails.LastName + " " +this.ConsultantDetails.FirstName;
                    this.StudentDetails.EmailAddress = this.ConsultantDetails.Email;
                }
                if( this.EmployerDetails.EmploymentStartDate == '')
                {
                         this.EmployerDetails.EmploymentStartDate = this.EmploymentStartDate
                }
            this.disableFinalEvaluationCheckbox = this.IsFinalEvaluationDone && this.StudentDetails.IsFinalEvalution == false;
            },
        removeDocUrl()
         {
           this.docUrl = ''
         },
         uploadComplete(v) {
                if (v[0].response.Url != null)
                {
                    this.docUrl = v[0].response.Url
                    this.isErrorMessageDisabled=false
                }
                if (v[0].response.State==false && v[0].response.Message!=null)
                {
                this.$refs.child1.CancelUpload()
                this.isErrorMessageDisabled=true
                this.errorMessageFrmResponse=v[0].response.Message
                }
         },
         onFromDateChange(e) {
                    this.$refs.OPTdateTo.data.minDate(e.date)
         },
         onRangeFromDateChange(e){
            this.$refs.rangeDateTo.data.minDate(e.date)
         },
        getCurrentOrganizationDetails()
        {
            this.$loading({loadingText: 'Please wait...'});
            ajax.get(`/Organization/GetCurrentUserOrganizationDetails`, {}, (res) => {
                if(res.data.State == true) {

                    this.EmployerDetails.Name = res.data.Organizationmodels.OrganizationName;
                }
             this.$loading({}).close();
            })
        },
         onUpload()
         {


            //    this.$v.StudentDetails.$touch();
            //    this.$v.EmployerDetails.$touch();
               this.$v.SignedDate.$touch();
               this.$v.SpecifyReason.$touch();


              if(this.$v.SignedDate.$invalid == false &&  this.$v.SpecifyReason.$invalid == false )
              {
                  this.$loading({'loadingText': 'Uploading Form I-983...'})
                 var employee = {
                    Name : this.StudentDetails.Name,
                    Email : this.StudentDetails.EmailAddress,
                    EmployeeId :this.EmployeeId,
                    DSO:this.StudentDetails.DSOName,
                    DSOPhone:this.StudentDetails.DSOPhone,
                    DSOMail:this.StudentDetails.DSOMail,
                    DSOAddress:this.StudentDetails.DSOAddress,
                    SEVISID:this.StudentDetails.StudentSEVISIdNo,
                    requestedFrom:this.StudentDetails.STEMOPTRequestedPeriodFrom,
                    requestedTo:this.StudentDetails.STEMOPTRequestedPeriodTo,
                 }
                 var employer = {
                    Name : this.EmployerDetails.Name,
                    OPTHours:this.EmployerDetails.OPTHoursPerWeek,
                    Salary:this.EmployerDetails.Salary,
                    SalaryFrequency:this.EmployerDetails.SalaryType,
                    EmploymentStartDate:this.EmployerDetails.EmploymentStartDate,
                 }
                 var SignedDocument = {
                     ConsultantId:this.ConsultantId,
                     DocumentUrl:this.docUrl,
                     SignedDate:this.SignedDate
                 }
                  var materialChange = {
                      MaterialChangeType : this.MaterialChange,
                      SpecifyReason : this.SpecifyReason
                  }
                  var evaluation = {
                       EvaluationFrom : this.StudentDetails.RangeOfEvaluationDateFrom,
                       EvaluationTo : this.StudentDetails.RangeOfEvaluationDateTo,
                       isFinalEvalution : this.StudentDetails.IsFinalEvalution
                  }
                  let I983Details = {
                    Employee:employee,
                    Employer:employer,
                    MaterialChange:this.I983Type == 'MaterialChange' ? materialChange : '',
                    Evaluation : this.I983Type == 'Evaluation' ? evaluation : '',
                    SignedDocument : SignedDocument,
                    Type :  this.I983Type,
                    IsInitiateOnlySectionType: true
                  }

                ajax.post(`/I983/Upload`,I983Details, (res) => {
                  if(res.data.State == true){
                      this.$emit('initiated');
                      this.$message({
                          type: 'success',
                          message: 'Form I-983 uploaded successfully'
                      });
                        this.show = false
                       this.$loading({}).close()
                  }else if(res.data.State == false){
                       this.show = false
                      this.$loading({}).close()
                      this.$message({
                          type: 'error',
                          message: res.data.Message
                      });
                  }
              });
              }
         },
    }
 }
</script>
<style lang="scss" scoped>
   .title-content
   {
       color: #4a90e2;
       font-size: 14px;
       padding-left: 0;
   }
   .img_design{
        width: 14px;
        border-radius: 25%;
        margin-left: 6px;
    }
   .rowgap
   {
       margin-top: 10px;
   }
   .validation-star{
            color: #F31D1D;
    }
    .radio-inline
    {
        padding-left: 0px
    }
    label{

         color :#a4abb9
    }
    .preview-details {
		padding: 10px 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/UploadI983Popup.vue